import { Box, ColorOptions, TextNew } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import styles from './styles'

const colorMap = {
  SUCCESS: 'GREEN',
  FAILED: 'ERROR',
  INPROCESS: 'ORANGE',
  ['REFUND ACCEPTED']: 'GREEN',
  ['REFUND FAILED']: 'ERROR',
  none: 'BLACK_21',
}

const getColor = (item: any) => {
  if (item.key === 'status') {
    return colorMap[(item.value as keyof typeof colorMap) || 'none']
  }
  return '#212121'
}

const RenderListItem = ({ item, index }: { item: any; index: number }) => {
  if (item?.value?.length === 0 || item?.value === 'NA' || item?.value === '₹ 0' || item?.value === '₹ 0.0') {
    return null
  }
  return (
    <Box {...styles.listItemContainer} f={1} key={index} pv={8}>
      <Box flex={0.4}>
        <TextNew
          color={'#757575' as ColorOptions}
          fontSize={14}
          // numberOfLines={1}
          fontFamily={'JioType-Medium'}
          lineHeight={20}
          letterSpacing={-0.07}>
          {item.key}
        </TextNew>
      </Box>
      <Box align={'flex-end'} paddingLeft={5} flex={0.6}>
        <TextNew
          fontSize={14}
          lineHeight={20}
          selectable
          fontFamily="JioType-Medium"
          color={getColor(item) as ColorOptions}
          textAlign={'right'}>
          {item?.value !== 'undefined' ? String(item?.value ?? 'NA') : 'NA'}
        </TextNew>
      </Box>
    </Box>
  )
}

export const TextLayout = ({ mapData }: any) => {
  if (isEmpty(mapData)) {
    return null
  }

  return (
    <Box>
      {mapData?.map((item: any, index: any) => {
        return <RenderListItem item={item} index={index} key={index} />
      })}
    </Box>
  )
}
